import { useEffect, useState } from 'react';
import './ToggleButton.scss';

type ToggleProps = {
    toggled: boolean;
    disabled: boolean;
    onClick: (state: boolean) => void;
};
const Toggle = ({ toggled, disabled, onClick }: ToggleProps) => {
    const [isToggled, toggle] = useState(false);
    useEffect(() => {
        toggle(toggled);
    }, [toggled]);

    const callback = () => {
        toggle(!isToggled);
        onClick(!isToggled);
    };

    return (
        <div className="toggleButton">
            <label className={` ${disabled ? ' disabledCheckbox' : ''}`}>
                <input type="checkbox" disabled={disabled} checked={isToggled} onClick={callback} />
                <span />
            </label>
        </div>
    );
};

export default Toggle;
